/* Christmas landing page behaviour: delivery countdowns, tea collection tabs,
   card rows, reels, campaign film, makers journey, peeking makers, mobile sticky bar and
   scroll reveals.
   The delivery cutoff comes from data-xmas-cutoff on sections/xmas-hero (or,
   with no hero on the page, on xmas-cta); snippets/xmas-delivery-state sets
   the first state before paint. Guarded so duplicate <script src> tags
   run once. */
(function () {
  if (window.__xmasInit) {
    return;
  }
  window.__xmasInit = true;

  var root = document.documentElement;
  var reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(scope, selector, fn) {
    var nodes = (scope || document).querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      fn(nodes[i], i);
    }
  }

  /* --- Countdown --------------------------------------------------------- */

  var timer = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  var cutoff = NaN;
  var preview = 'auto';

  /* Read on boot and whenever the editor reloads a section. The hero owns the
     cutoff; on pages without one (e.g. the homepage) the first section that
     carries its own cutoff, such as xmas-cta, is used instead. */
  function readConfig() {
    var source =
      document.querySelector('[data-xmas-hero]') || document.querySelector('[data-xmas-cutoff]');
    var iso = source ? source.getAttribute('data-xmas-cutoff') : '';
    cutoff = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:00[+-]\d{2}:\d{2}$/.test(iso) ? Date.parse(iso) : NaN;
    preview = (source && source.getAttribute('data-xmas-preview')) || 'auto';
  }

  function tick() {
    if (isNaN(cutoff)) {
      root.setAttribute('data-xmas-delivery', 'none');
      return;
    }
    var left = Math.max(0, Math.floor((cutoff - Date.now()) / 1000));
    var forced = preview === 'open' || preview === 'closed';
    var state = forced ? preview : left > 0 ? 'open' : 'closed';
    root.setAttribute('data-xmas-delivery', state);

    var parts = {
      days: Math.floor(left / 86400),
      hours: Math.floor((left % 86400) / 3600),
      minutes: Math.floor((left % 3600) / 60),
      seconds: left % 60
    };

    each(document, '[data-xmas-countdown]', function (el) {
      each(el, '[data-xmas-unit]', function (num) {
        var text = pad(parts[num.getAttribute('data-xmas-unit')]);
        if (num.textContent !== text) {
          num.textContent = text;
        }
      });
      /* Screen readers get a minute-level label, not a per-second stream. */
      var t = el.querySelector('[data-xmas-timer]');
      if (t) {
        var label = parts.days + ' days ' + parts.hours + ' hours ' + parts.minutes + ' minutes';
        if (t.getAttribute('aria-label') !== label) {
          t.setAttribute('aria-label', label);
        }
      }
    });

    var compact =
      (parts.days > 0 ? parts.days + 'd ' : '') +
      pad(parts.hours) + ':' + pad(parts.minutes) + ':' + pad(parts.seconds);
    each(document, '[data-xmas-compact-clock]', function (el) {
      el.textContent = compact;
    });

    clearTimeout(timer);
    if (state === 'open' && left > 0 && !document.hidden) {
      timer = setTimeout(tick, 1000 - (Date.now() % 1000));
    }
  }

  /* --- Card rows --------------------------------------------------------- */

  function bindRow(row) {
    if (row.__xmasUpdate) {
      row.__xmasUpdate();
      return;
    }
    var track = row.querySelector('[data-xmas-row-track]');
    var prev = row.querySelector('[data-xmas-row-prev]');
    var next = row.querySelector('[data-xmas-row-next]');
    var bar = row.querySelector('.xmas-row__progress-bar');
    if (!track || !prev || !next) {
      return;
    }
    var frame = null;

    function update() {
      frame = null;
      var max = track.scrollWidth - track.clientWidth;
      var x = Math.abs(track.scrollLeft);
      prev.disabled = x <= 2;
      next.disabled = x >= max - 2;
      row.classList.toggle('xmas-row--static', max <= 2);
      if (bar && track.scrollWidth > 0) {
        bar.style.width = (track.clientWidth / track.scrollWidth) * 100 + '%';
        bar.style.transform =
          'translateX(' + (track.clientWidth ? (x / track.clientWidth) * 100 : 0) + '%)';
      }
    }

    function queue() {
      if (frame === null) {
        frame = requestAnimationFrame(update);
      }
    }

    function page(direction) {
      var rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      track.scrollBy({
        left: direction * rtl * track.clientWidth * 0.9,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () {
      page(-1);
    });
    next.addEventListener('click', function () {
      page(1);
    });
    track.addEventListener('scroll', queue, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(queue).observe(track);
    }

    row.__xmasUpdate = queue;
    update();
  }

  /* --- Reels ------------------------------------------------------------- */

  var reelObserver = null;

  function setPlaying(reel, playing) {
    var video = reel.querySelector('video');
    var toggle = reel.querySelector('[data-xmas-reel-toggle]');
    if (!video) {
      return;
    }
    if (playing) {
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {});
      }
    } else {
      video.pause();
    }
    if (toggle) {
      toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
    }
  }

  /* Plays muted while on screen and in the open tab, unless the visitor
     paused it or prefers reduced motion. */
  function syncReel(reel) {
    var panel = reel.closest('[data-xmas-tabpanel]');
    var shown = !panel || !panel.hidden;
    setPlaying(reel, shown && reel.__xmasInView && !reel.__xmasPaused && !reducedMotion);
  }

  function bindReel(reel) {
    if (reel.__xmasBound) {
      return;
    }
    reel.__xmasBound = true;
    reel.__xmasPaused = reducedMotion;
    var toggle = reel.querySelector('[data-xmas-reel-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var video = reel.querySelector('video');
        var playing = video && !video.paused;
        reel.__xmasPaused = playing;
        setPlaying(reel, !playing);
      });
    }
    if (!('IntersectionObserver' in window)) {
      return;
    }
    if (!reelObserver) {
      reelObserver = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            entries[i].target.__xmasInView = entries[i].isIntersecting;
            syncReel(entries[i].target);
          }
        },
        { threshold: 0.4 }
      );
    }
    reelObserver.observe(reel);
  }

  /* --- Campaign film ---------------------------------------------------- */

  /* The film loads only on press, so it costs nothing until watched. */
  function bindFilm(frame) {
    var play = frame.querySelector('[data-xmas-film-play]');
    var media = frame.querySelector('[data-xmas-film-media]');
    if (!play || !media || play.__xmasBound) {
      return;
    }
    play.__xmasBound = true;
    play.addEventListener('click', function () {
      frame.appendChild(media.content.cloneNode(true));
      play.remove();
      var video = frame.querySelector('video');
      if (video) {
        fitPortrait(frame, video);
        video.focus();
        var p = video.play();
        if (p && p.catch) {
          p.catch(function () {});
        }
      } else {
        var iframe = frame.querySelector('iframe');
        if (iframe) {
          iframe.focus();
        }
      }
    });
  }

  /* Fallback for a film whose shape Liquid could not read: once the video
     knows its size, a vertical one switches the frame to its own shape. */
  function fitPortrait(frame, video) {
    function check() {
      var w = video.videoWidth;
      var h = video.videoHeight;
      if (!w || !h || w >= h || frame.classList.contains('xmas-film__frame--portrait')) {
        return;
      }
      frame.style.setProperty('--xmas-film-ratio', String(w / h));
      frame.classList.add('xmas-film__frame--portrait');
    }
    if (video.readyState >= 1) {
      check();
    } else {
      video.addEventListener('loadedmetadata', check, { once: true });
    }
  }

  /* --- Tabs -------------------------------------------------------------- */

  function bindTabs(section) {
    var list = section.querySelector('[data-xmas-tablist]');
    if (!list || list.__xmasSelect) {
      return;
    }
    var tabs = list.querySelectorAll('[role="tab"]');
    var panels = section.querySelectorAll('[data-xmas-tabpanel]');
    if (!tabs.length || tabs.length !== panels.length) {
      return;
    }

    function select(index, focus) {
      for (var i = 0; i < tabs.length; i++) {
        var on = i === index;
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].tabIndex = on ? 0 : -1;
        panels[i].hidden = !on;
      }
      if (focus) {
        tabs[index].focus();
      }
      /* Keep the active chip in view on narrow screens. */
      var tab = tabs[index];
      list.scrollTo({
        left: tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
      each(section, '[data-xmas-reel]', syncReel);
      each(panels[index], '[data-xmas-row]', function (row) {
        if (row.__xmasUpdate) {
          row.__xmasUpdate();
        }
      });
    }

    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener(
        'click',
        (function (index) {
          return function () {
            select(index, false);
          };
        })(i)
      );
    }

    list.addEventListener('keydown', function (event) {
      var current = Array.prototype.indexOf.call(tabs, document.activeElement);
      if (current === -1) {
        return;
      }
      var rtl = getComputedStyle(list).direction === 'rtl';
      var forward = rtl ? 'ArrowLeft' : 'ArrowRight';
      var back = rtl ? 'ArrowRight' : 'ArrowLeft';
      var target = null;

      if (event.key === forward) {
        target = (current + 1) % tabs.length;
      } else if (event.key === back) {
        target = (current - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        target = 0;
      } else if (event.key === 'End') {
        target = tabs.length - 1;
      }
      if (target !== null) {
        event.preventDefault();
        select(target, true);
      }
    });

    list.hidden = false;
    list.__xmasSelect = select;
    list.__xmasTabs = tabs;

    if (!selectFromHash(section)) {
      select(0, false);
    }
  }

  /* #gifts-for-professionals opens that collection, so ads and emails can link
     straight to it. */
  function selectFromHash(scope) {
    var hash = decodeURIComponent((location.hash || '').slice(1));
    if (!hash) {
      return false;
    }
    var found = false;
    each(scope || document, '[data-xmas-tablist]', function (list) {
      if (found || !list.__xmasSelect) {
        return;
      }
      for (var i = 0; i < list.__xmasTabs.length; i++) {
        if (list.__xmasTabs[i].getAttribute('data-xmas-hash') === hash) {
          list.__xmasSelect(i, false);
          var section = list.closest('.xmas');
          if (section) {
            section.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
          }
          found = true;
          return;
        }
      }
    });
    return found;
  }

  /* --- Sticky bar -------------------------------------------------------- */

  var stickyObserver = null;

  function bindSticky() {
    var bar = document.querySelector('[data-xmas-sticky]');
    var hero = document.querySelector('[data-xmas-hero]');
    if (stickyObserver) {
      stickyObserver.disconnect();
      stickyObserver = null;
    }
    if (!bar || !hero || !('IntersectionObserver' in window)) {
      return;
    }

    var visible = new Map();
    bar.inert = true;

    stickyObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        visible.set(entries[i].target, entries[i].isIntersecting);
      }
      var show = true;
      visible.forEach(function (isVisible) {
        if (isVisible) {
          show = false;
        }
      });
      bar.classList.toggle('xmas-sticky--visible', show);
      bar.inert = !show;
    });

    stickyObserver.observe(hero);
    each(document, '[data-xmas-cta]', function (cta) {
      stickyObserver.observe(cta);
    });
  }

  /* --- Makers journey ---------------------------------------------------
     On first view the gold path draws from step to step and each maker
     steps into their arch. On the swipeable layout the card in focus is lit
     and the path fills up to it, so visitors see how far through they are.
     The makers' idle motion only runs while the section is on screen. */

  var JOURNEY_STEP_MS = 380;

  function bindJourney(list) {
    if (list.__xmasJourneyBound) {
      return;
    }
    list.__xmasJourneyBound = true;

    var steps = list.querySelectorAll('[data-xmas-journey-step]');
    var swipe = window.matchMedia('(max-width: 1199px)');
    var active = 0;
    var played = false;

    function setActive(index) {
      active = index;
      for (var i = 0; i < steps.length; i++) {
        var lit = swipe.matches ? i <= index : played;
        steps[i].classList.toggle('is-lit', lit);
        steps[i].classList.toggle('is-active', i === index);
      }
    }

    function nearest() {
      var start = list.getBoundingClientRect().left + parseFloat(getComputedStyle(list).scrollPaddingLeft || 0);
      var best = 0;
      var bestDistance = Infinity;
      for (var i = 0; i < steps.length; i++) {
        var distance = Math.abs(steps[i].getBoundingClientRect().left - start);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      }
      /* At the end of the row the last cards cannot reach the start edge. */
      if (list.scrollLeft + list.clientWidth >= list.scrollWidth - 4) {
        best = steps.length - 1;
      }
      return best;
    }

    var queued = false;
    list.addEventListener(
      'scroll',
      function () {
        if (queued || !swipe.matches) {
          return;
        }
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          list.classList.remove('xmas-journey--nudge');
          setActive(nearest());
        });
      },
      { passive: true }
    );

    function onLayoutChange() {
      list.classList.toggle('is-tracking', swipe.matches);
      setActive(swipe.matches ? nearest() : active);
    }
    if (swipe.addEventListener) {
      swipe.addEventListener('change', onLayoutChange);
    } else if (swipe.addListener) {
      swipe.addListener(onLayoutChange);
    }

    function play() {
      if (played) {
        return;
      }
      played = true;
      list.classList.toggle('is-tracking', swipe.matches);
      if (reducedMotion) {
        each(list, '[data-xmas-journey-step]', function (step) {
          step.classList.add('is-seen');
        });
        setActive(swipe.matches ? nearest() : 0);
        return;
      }
      each(list, '[data-xmas-journey-step]', function (step, i) {
        setTimeout(function () {
          step.classList.add('is-seen');
          if (!swipe.matches) {
            step.classList.add('is-lit');
          }
        }, i * JOURNEY_STEP_MS);
      });
      if (swipe.matches) {
        setActive(nearest());
        /* A small nudge shows the row swipes, unless they already did. */
        setTimeout(function () {
          if (list.scrollLeft < 4) {
            list.classList.add('xmas-journey--nudge');
          }
        }, 900);
      }
    }

    if (reducedMotion || !('IntersectionObserver' in window)) {
      play();
      return;
    }

    new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        list.classList.toggle('is-onscreen', entry.isIntersecting);
        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
          play();
        }
      },
      { threshold: [0, 0.25] }
    ).observe(list);
  }

  /* --- Peeking makers ---------------------------------------------------
     Slide in while their spot passes through the middle of the screen, and
     slip back out once it has gone by, so they can greet visitors again on
     the way back up. */

  var peekObserver = null;

  function bindPeek(peek) {
    if (peek.__xmasPeekBound || !('IntersectionObserver' in window)) {
      return;
    }
    peek.__xmasPeekBound = true;
    if (!peekObserver) {
      peekObserver = new IntersectionObserver(
        function (entries) {
          for (var e = 0; e < entries.length; e++) {
            entries[e].target.classList.toggle('is-peeking', entries[e].isIntersecting);
          }
        },
        { rootMargin: '-28% 0px -28% 0px' }
      );
    }
    peekObserver.observe(peek);
  }

  /* --- Hero video -------------------------------------------------------
     Plays only the video that is showing (desktop or mobile), muted and on a
     loop, with a pause button. Visitors who ask for reduced motion get the
     still first frame and can press play. */

  function bindHeroVideo(frame) {
    if (frame.__xmasVideoBound) {
      return;
    }
    frame.__xmasVideoBound = true;
    var section = frame.closest('.xmas-hero');
    var toggle = section && section.querySelector('[data-xmas-hero-video-toggle]');
    var videos = frame.querySelectorAll('.xmas-hero__video-el');

    function current() {
      for (var i = 0; i < videos.length; i++) {
        if (getComputedStyle(videos[i]).display !== 'none') {
          return videos[i];
        }
      }
      return null;
    }

    function sync(video) {
      if (!toggle || !video) {
        return;
      }
      toggle.hidden = false;
      toggle.classList.toggle('is-paused', video.paused);
      toggle.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    }

    function play(video) {
      for (var i = 0; i < videos.length; i++) {
        if (videos[i] !== video) {
          videos[i].pause();
        }
      }
      if (!video) {
        return;
      }
      video.muted = true;
      var attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () {
          sync(video);
        });
      }
    }

    for (var v = 0; v < videos.length; v++) {
      videos[v].addEventListener('play', function (e) { sync(e.target); });
      videos[v].addEventListener('pause', function (e) { sync(e.target); });
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var video = current();
        if (!video) {
          return;
        }
        if (video.paused) {
          play(video);
        } else {
          video.pause();
        }
      });
    }

    var video = current();
    if (reducedMotion) {
      sync(video);
    } else {
      play(video);
    }
  }

  /* --- Reveal ------------------------------------------------------------ */

  var revealObserver = null;

  function reveal(scope) {
    if (reducedMotion || !('IntersectionObserver' in window)) {
      each(scope, '[data-xmas-reveal]', function (target) {
        target.classList.add('xmas-reveal--in');
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          for (var e = 0; e < entries.length; e++) {
            if (!entries[e].isIntersecting) {
              continue;
            }
            entries[e].target.classList.add('xmas-reveal--in');
            revealObserver.unobserve(entries[e].target);
          }
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }

    var sections = [];
    if (scope && scope.classList && scope.classList.contains('xmas')) {
      sections.push(scope);
    }
    each(scope, '.xmas', function (section) {
      sections.push(section);
    });
    for (var s = 0; s < sections.length; s++) {
      each(sections[s], '[data-xmas-reveal]', function (target, index) {
        if (target.__xmasRevealBound) {
          return;
        }
        target.__xmasRevealBound = true;
        target.style.setProperty('--xmas-delay', Math.min(index, 6) * 90 + 'ms');
        revealObserver.observe(target);
      });
    }
  }

  /* --- Boot -------------------------------------------------------------- */

  function bindAll(scope) {
    each(scope, '[data-xmas-row]', bindRow);
    each(scope, '[data-xmas-reel]', bindReel);
    each(scope, '[data-xmas-film]', bindFilm);
    each(scope, '[data-xmas-journey]', bindJourney);
    each(scope, '[data-xmas-peek]', bindPeek);
    each(scope, '[data-xmas-hero-video]', bindHeroVideo);
    each(scope, '[data-xmas-tabs]', bindTabs);
    bindSticky();
    reveal(scope);
  }

  function init() {
    readConfig();
    bindAll(document);
    tick();

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        tick();
      }
    });
    window.addEventListener('hashchange', function () {
      selectFromHash(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-renders sections in place. */
  document.addEventListener('shopify:section:load', function (event) {
    readConfig();
    bindAll(event.target);
    tick();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var tab = event.target.closest && event.target.closest('[role="tab"]');
    var list = tab && tab.closest('[data-xmas-tablist]');
    if (list && list.__xmasSelect) {
      list.__xmasSelect(Array.prototype.indexOf.call(list.__xmasTabs, tab), false);
    }
  });
})();
